import { DirectionEnum } from 'config';
const DOCUMENT_DIR_KEY = 'dir';

const getDocumentDirection = () => (localStorage.getItem(DOCUMENT_DIR_KEY) || 'ltr') as DirectionEnum;

export { DOCUMENT_DIR_KEY, getDocumentDirection };
